import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, RouterLink } from "@angular/router";
import { combineLatest, Observable, Subject, of } from "rxjs";
import { MarketService } from "../../../../../../../../../shared/src/lib/services/market.service";
import { LoaderService } from "../../../../../../../../../shared/src/lib/services/loader.service";
import { ShimmerLoaderComponent } from "../../../../../../shared/components/shimmer-loader/shimmer-loader.component";
import { AsyncPipe, CommonModule } from "@angular/common";
import { filter, map, takeUntil } from "rxjs/operators";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-leagues-sub-tab",
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterLink, ShimmerLoaderComponent],
  templateUrl: "./leagues-sub-tab.component.html",
  styleUrl: "./leagues-sub-tab.component.scss",
})
export class LeaguesSubTabComponent implements OnInit, OnDestroy {
  readonly destroy$ = new Subject<void>();
  marketService = inject(MarketService);
  loader = inject(LoaderService);
  route = inject(ActivatedRoute);

  sportId = "";
  currentSport = "";
  popularLeagues: any[] = [];
  allLeagues: { letter: string; leagues: any[] }[] = [];
  $loading!: Observable<boolean>;

  sportIds: Record<string, string> = {
    soccer: "1",
    cricket: "4",
    tennis: "2",
  };

  ngOnInit() {
    this.$loading = this.loader.isLoading("/bf/competitions/");

    this.route.parent?.parent?.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.currentSport = params["sport"];
      this.sportId = this.sportIds[this.currentSport] || "";
      if (this.sportId) {
        this.fetchData();
      }
    });
  }

  fetchData() {
    combineLatest([this.marketService.fetchCompetitions(this.sportId), this.marketService.promoted$])
      .pipe(
        filter(([resp, promoted]) => !!resp && !!promoted),
        takeUntil(this.destroy$)
      )
      .subscribe(([resp, promoted]: [any, any]) => {
        const leagues = resp?.data || [];
        const promotedLeagues = promoted?.promotedLeagues || [];
        const promotedLeagueIds = promotedLeagues.map((l: any) => String(l.leagueId));

        this.popularLeagues = leagues.filter((l: any) => promotedLeagueIds.includes(String(l.id)));
        this.groupLeagues(leagues);
      });
  }

  groupLeagues(leagues: any[]) {
    const sorted = [...leagues].sort((a, b) => a.name.localeCompare(b.name));
    const groups: Record<string, any[]> = {};

    sorted.forEach((league) => {
      const firstLetter = league.name.charAt(0).toUpperCase();
      if (!groups[firstLetter]) {
        groups[firstLetter] = [];
      }
      groups[firstLetter].push(league);
    });

    this.allLeagues = Object.keys(groups)
      .sort()
      .map((letter) => ({
        letter,
        leagues: groups[letter],
      }));
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
